import Vue from "vue";
import Router, { Route } from "vue-router";
import {
  checkIfPathIsVerifiedByUuid,
  retrieveToken,
  tokenValid,
  verifyUuid
} from "../services/AuthService";
import store from "@/vuex/store";
/* All MBE components */
import {
  loginDentalProRouting,
  loginRouting
} from "../components/login/router";
import RecordsRouting from "../components/records/router";
import ShipmentsRouting from "../components/shipments/router";
import BillingRouting from "../components/billing/router";
import SetupRouting from "../components/setup/router";
import ApiKeyRouting from "../components/setup/apikey/router";
import DefaultPackagingRouting from "../components/setup/defaultPackaging/router";
import TradetermsRouting from "../components/tradeterms/router";
import RegisterRouting from "../components/register/router";
import Page404 from "../components/page-404/router";
import { homeRouting } from "@/components/home/router";
import DeviceManagementRouting from "@/components/setup/deviceManagement/router";
import LoginHistoryRouting from "@/components/setup/loginHistory/router";

Vue.use(Router);
// Routes
const router = new Router({
  mode: "history",
  routes: [
    /* Redirect to dashboard */
    {
      path: "/",
      redirect: "/home"
    },
    loginRouting,
    loginDentalProRouting,
    homeRouting,
    RecordsRouting,
    BillingRouting,
    ShipmentsRouting,
    SetupRouting,
    ApiKeyRouting,
    DefaultPackagingRouting,
    TradetermsRouting,
    RegisterRouting,
    Page404,
    LoginHistoryRouting,
    DeviceManagementRouting
  ],
  // Automatic scroll on top
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  linkActiveClass: "active"
});

// AuthGuard
router.beforeEach(async (to: Route, from: Route, next) => {
  if (!to.meta.layout) {
    to.meta.layout = "Default";
  }
  if (to.path === "/page-404") {
    return next();
  }
  const isTokenValid = tokenValid(null);
  const isPathVerifiedByUuid =
    to.params &&
    to.params.id &&
    checkIfPathIsVerifiedByUuid(to.fullPath, to.params.id);
  if (isPathVerifiedByUuid) {
    store.commit("setLayout", to.meta.layout || "default");
    if (await verifyUuid(to.params.id)) {
      return next();
    } else {
      return next("/page-404");
    }
  }
  if (to.path === "/login") {
    const paramsFromHub = to.query.token;
    if (paramsFromHub) {
      return next();
    } else {
      return tokenValid(null) ? next("/home") : next();
    }
  }

  if (to.path === "/dental-pro/login") {
    return next();
  }

  if (
    to.path !== "/login" &&
    to.path !== "/dental-pro/login" &&
    !isTokenValid
  ) {
    console.warn("token is not valid");
    return next("/login");
  } else {
    return next();
  }
});

export default router;
